import { CurrencySetting, Point } from "../../type";

export type MatchedLine = {
  points: { x: number; y: number }[];
  win: number;
  beforeWin: number;
};

export type HippoSplashGameData = {
  category: number;
  animationGroups?: { [k: string]: MatchedLine };
  totalMultiplier: number;
  multiplier: number;
  triggeredFeaturePoint?: Point;
  playWin?: number;
  featureSymbol?: number;
};

export enum Symbols {
  Symbol1 = 201,
  Symbol2 = 202,
  Symbol3 = 203,
  Symbol4 = 204,
  Symbol5 = 205,
  Symbol6 = 206,

  Wild = 21,
}

export enum FeatureSymbols {
  None = 0,
  IceValue = 1,
  Bomb = 5,
  GummyRocket = 4,
  Chocolate = 3,
  MysterySweet = 2,
  RocketRocket = 44,
  ChocolateChocolate = 33,
  MysterySweetSweet = 22,
  RocketChocolate = 43,
  RocketMysterySweet = 42,
  ChocolateMysterySweet = 32,
  SugarBlast = 8,
  IceBomb = 7,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: Payout };
  buyFreeSpinRate: number;
};

export type Payout = { [k: string]: number };

export type SpinHistory = {
  id: string;
  level: number;
  reelMatrix: number[][];
  addedFreeSpin: number;
  gameData: HippoSplashGameData;
  state: string;
  winAmount: string;
  mode: string;
  spinDate: string;
  playRefNumber: string;
  focus: boolean;
};

export type Payline = {
  paylineId: number;
  matchedPayline: Point[];
  symbolId: number;
  count: number;
  payout: number;
  win: number;
};
